import type { MouseEvent, ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Mode-panel noun row (Basecamp Bookmarks/Todos, Inbox folders).
 * Hover/active come from `.ws-nav-item` + ancestor `--ws-color` (`wsNavSectionStyle`).
 * `open` = working-set echo (tab open elsewhere; wash + trailing dot).
 */
export function ModePanelNavItem({
  active = false,
  open = false,
  dense = false,
  icon,
  label,
  trailing,
  onClick,
  title,
  'data-testid': testId,
}: {
  active?: boolean
  /** Open in a tab but not focused. */
  open?: boolean
  dense?: boolean
  icon?: ReactNode
  label: ReactNode
  trailing?: ReactNode
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  title?: string
  'data-testid'?: string
}) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      aria-current={active ? 'page' : undefined}
      data-testid={testId}
      data-open={open && !active ? 'true' : undefined}
      className={cn(
        'ws-nav-item flex w-full items-center gap-2 px-3 text-left text-sm select-none',
        dense ? 'py-1.5' : 'py-2',
        active
          ? 'ws-nav-item--active text-sidebar-foreground'
          : open
            ? 'ws-nav-item--open'
            : 'text-sidebar-foreground/70',
      )}
    >
      {icon}
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {trailing}
    </button>
  )
}
